import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminService } from '../services/admin.service';

const useRefresh = () => {
    const queryClient = useQueryClient();
    return () => {
        void queryClient.invalidateQueries({ queryKey: ['admin'] });
        void queryClient.invalidateQueries({ queryKey: ['hangouts'] });
        void queryClient.invalidateQueries({ queryKey: ['markets'] });
        void queryClient.invalidateQueries({ queryKey: ['roster'] });
    };
};

export const useOverview = () =>
    useQuery({ queryKey: ['admin', 'overview'], queryFn: () => adminService.overview() });

export const useAdminUsers = () =>
    useQuery({ queryKey: ['admin', 'users'], queryFn: () => adminService.users() });

export const useAudit = () =>
    useQuery({ queryKey: ['admin', 'audit'], queryFn: () => adminService.audit() });

export const useCreateUser = () => {
    const refresh = useRefresh();
    return useMutation({
        mutationFn: (input: { handle: string; pin: string; isAdmin?: boolean }) =>
            adminService.createUser(input),
        onSuccess: refresh,
    });
};

export const useUpdateUser = () => {
    const refresh = useRefresh();
    return useMutation({
        mutationFn: (vars: {
            id: number;
            patch: { handle?: string; isAdmin?: boolean; pin?: string; unlock?: boolean };
        }) => adminService.updateUser(vars.id, vars.patch),
        onSuccess: refresh,
    });
};

export const useCreateHangoutAdmin = () => {
    const refresh = useRefresh();
    return useMutation({
        mutationFn: (input: {
            name: string;
            venue?: string;
            startingStake?: number;
            maxStakePerMarket?: number;
        }) => adminService.createHangout(input),
        onSuccess: refresh,
    });
};


export const useAddPlayer = () => {
    const refresh = useRefresh();
    return useMutation({
        mutationFn: (vars: { hangoutId: number; userId: number }) =>
            adminService.addPlayer(vars.hangoutId, vars.userId),
        onSuccess: refresh,
    });
};

export const useCloseHangout = () => {
    const refresh = useRefresh();
    return useMutation({
        mutationFn: (id: number) => adminService.closeHangout(id),
        onSuccess: refresh,
    });
};

export const useAdjust = () => {
    const refresh = useRefresh();
    return useMutation({
        mutationFn: (input: {
            hangoutId: number;
            userId: number;
            delta: number;
            reason: string;
        }) => adminService.adjust(input),
        onSuccess: refresh,
    });
};
